<template>
  <div>
    <AppTooltip>
      <template #activator="{ props }">
        <app-button
          type="icon"
          size="small"
          v-bind="props"
          @click="isOpen = true"
        >
          <app-material-icon
            v-if="!withTrashIcon"
            name="close"
          />
          <app-material-icon
            v-else
            name="delete"
          />
        </app-button>
      </template>
      <span>{{$t('project.members.dialogs.MemberDeleteDialog.removeMemberTooltip')}}</span>
    </AppTooltip>
    <app-modal :model-value="isOpen"
               size="xs"
               @cancel="close"
               @ok="prepareDeleteMember"
    >
      <template #title>{{ $t('project.members.dialogs.MemberDeleteDialog.title') }}</template>
      <template #body>{{ $t('project.members.dialogs.MemberDeleteDialog.text') }}</template>
    </app-modal>

    <app-modal :model-value="lastSubscriberModalIsOpen"
               size="xs"
               ok-only
               :ok-text="$t('common.close')"
               @cancel="lastSubscriberModalIsOpen = false"
               @ok="close"
    >
      <template #title>{{ $t('project.members.dialogs.MemberDeleteDialog.lastSubscriberModalTitle') }}</template>
      <template #body>{{ $t('project.members.dialogs.MemberDeleteDialog.lastSubscriberModalText', {subName: subName}) }}</template>
    </app-modal>

    <app-modal :model-value="removeMemberWithSignatureIsOpen"
               size="xs"
               @cancel="close"
               @ok="prepareDeleteMember(true)"
    >
      <template #title>{{ $t('project.members.dialogs.MemberDeleteDialog.removeMemberWithSignatureModalTitle') }}</template>
      <template #body>
        <v-row>
          <v-col>
            {{ $t('project.members.dialogs.MemberDeleteDialog.removeMemberWithSignatureModalText') }}
          </v-col>
        </v-row>
        <v-row v-if="memberToRemoveFromGroupWithSignature">
          <v-col>
            <ul class="px-3" style="list-style-position: inside">
              <li v-for="(doc, i) in memberToRemoveFromGroupWithSignature.docs" :key="`doc-${i}`">
                {{doc}}
              </li>
            </ul>
          </v-col>
        </v-row>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { toast } from '@/common/utils/toast'

export default {
  name: 'MemberDeleteDialog',
  components: {
    AppTooltip,
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    withTrashIcon: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isOpen: false,
      subName: null,
      lastSubscriberModalIsOpen: false,
      removeMemberWithSignatureIsOpen: false,
      memberToRemoveFromGroupWithSignature: null,
    }
  },
  methods: {
    ...mapActions('groups', ['DELETE_MEMBER', 'GET_GROUPS']),
    close () {
      this.isOpen = false
      this.subName = null
      this.lastSubscriberModalIsOpen = false
      this.removeMemberWithSignatureIsOpen = false
      this.memberToRemoveFromGroupWithSignature = null
    },
    prepareDeleteMember (force = false) {
      this.DELETE_MEMBER({ memberId: this.member.id, params: { confirmVoidSignatures: force } })
        .then(() => {
          this.GET_GROUPS(this.$route.params.mnemo)
          this.isOpen = false
          toast.success(this.$t('project.members.dialogs.MemberDeleteDialog.messages.successRemoveAccess'))
        })
        .catch(error => {
          if (error.response?.data?.error === 'ERR_ROOM_NEED_SUBSCRIBED_USER') {
            this.isOpen = false
            this.subName = error.response?.data?.subscription?.name
            this.lastSubscriberModalIsOpen = true
            toast.error(this.$t('project.members.dialogs.MemberDeleteDialog.messages.errorRemoveAccess'))
          } else if (error.response?.status === 300 && error.response?.data?.length > 0) {
            this.memberToRemoveFromGroupWithSignature = {
              docs: error.response?.data,
            }
            this.isOpen = false
            this.removeMemberWithSignatureIsOpen = true
          } else {
            this.isOpen = false
            toast.error(this.$t('project.members.dialogs.MemberDeleteDialog.messages.errorRemoveAccess'))
            throw error
          }
        })
    },
  },
}
</script>
